module.exports = __webpack_public_path__ + "static/media/messa2_thumb_even.065039a3.jpg";